import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const PlanZone = () => (
  <ReportLayout title="Planning Board and Zoning Board Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="pz_application/download"
    />
  </ReportLayout>
);

export default PlanZone;
